import { useEffect, useState } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

/**
 * Client-only `prefers-reduced-motion` flag. Always initializes to `false` (motion allowed) so
 * server-rendered/prerendered markup and the first client paint agree (no hydration mismatch) —
 * exactly the same "safe default, correct itself after mount" pattern already used by
 * `Header`'s `scrolled` state and `StickyCta`'s `visible` state in this codebase. Any *rendered
 * content* must never depend on this value; it only gates optional client-side motion (autoplay,
 * decorative animation classes, scroll-behavior choices).
 */
export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mql = window.matchMedia(QUERY);
    setReduced(mql.matches);

    function handleChange(event: MediaQueryListEvent) {
      setReduced(event.matches);
    }

    if (typeof mql.addEventListener === "function") {
      mql.addEventListener("change", handleChange);
      return () => mql.removeEventListener("change", handleChange);
    }
    // Safari <14 fallback.
    mql.addListener(handleChange);
    return () => mql.removeListener(handleChange);
  }, []);

  return reduced;
}
